export default {
  TEMPLATES (state) {
    return state.templates
  },
  TEMPLATE (state) {
    return state.template
  },
  BLOCKS (state) {
    return state.blocks
  },
  SELECTED_BLOCK (state) {
    if (!state.selectedBlockId) return null
    return state.blocks.find(function (b) { return b._id === state.selectedBlockId }) || null
  }
}
